/* eslint-disable security/detect-object-injection */
import { ICoreContext, IGeneric, IAny } from '@msdyn365-commerce/core';

import { AttributeValueBase, Customer, DiscountLine, ProductPrice, AttributeValue } from '@msdyn365-commerce/retail-proxy';
import React from 'react';

// VSI Customization for Currency formatter Funciton are created to get curreny with A$ sign
export const currencyFormat = (amount?: number, context?: ICoreContext<IGeneric<IAny>>): string | null => {
    if (!amount || !context) {
        return null;
    }

    return context.cultureFormatter.formatCurrency(Number(amount));
};

// Set Order and Cart Attribues
export const setNameAttribute = (attrName: string, value: string): AttributeValueBase => {
    const privIdAttribute = {
        // @ts-ignore
        '@odata.type': '#Microsoft.Dynamics.Commerce.Runtime.DataModel.AttributeTextValue',
        Name: attrName,
        ExtensionProperties: [],
        TextValue: value,
        TextValueTranslations: []
    };

    return privIdAttribute as AttributeValueBase;
};

// Find  attribute id exist update it other wise push

export const findAttribute = async (
    currentAttributes: AttributeValueBase[],
    attributeObj: AttributeValueBase
): Promise<AttributeValueBase[]> => {
    const attrIndex = currentAttributes.findIndex(
        (attr: AttributeValueBase) => attr.Name?.toLowerCase() === attributeObj.Name?.toLowerCase()
    );

    if (attrIndex > -1) {
        currentAttributes[attrIndex] = attributeObj;
    } else {
        currentAttributes.push(attributeObj);
    }

    return currentAttributes;
};

export const getAttributeValues = async (
    currentAttributes: AttributeValueBase[],
    attributeObj: AttributeValueBase
): Promise<AttributeValueBase[]> => {
    const attrIndex = currentAttributes.findIndex(
        (attr: AttributeValueBase) => attr.Name?.toLowerCase() === attributeObj.Name?.toLowerCase()
    );

    if (attrIndex > -1) {
        currentAttributes[attrIndex] = attributeObj;
    } else {
        currentAttributes.push(attributeObj);
    }

    return currentAttributes;
};

export function getOrderStatus(statusValue: Number | undefined) {
    if (statusValue === 0) {
        return 'Open Order';
    } else if (statusValue === 1) {
        return 'Processing';
    } else if (statusValue === 3) {
        return 'Shipped';
    } else if (statusValue === 4) {
        return 'Invoiced';
    } else if (statusValue === 7) {
        return 'Canceled';
    } else if (!statusValue) {
        return 'Open Order';
    } else {
        return 'Open Order';
    }
}

export const getDiscountType = (discountArray: DiscountLine[], discountType: string) => {
    return discountArray.find((discountLine: DiscountLine) => {
        if (discountLine.OfferName?.toLowerCase().trim() === discountType.toLowerCase().trim()) {
            return true;
        }
        return false;
    });
};

// tslint:disable

export const hasArray = (values: any): any[] | undefined => {
    return typeof values !== 'string' && values && values.length ? values : undefined;
};

export const incExcPriceFormat = (
    value: number,
    context?: ICoreContext<IGeneric<IAny>>,
    enabledIncExPrices?: boolean,
    inclusiveRate?: number,
    decimalPlaces?: number
): string | JSX.Element => {
    if (!value) {
        return <></>;
    }
    const getPrice = (inc?: number): string => {
        const calculatedPrice = inc ? value * inc : value;
        const formattedPrice =
            decimalPlaces && decimalPlaces > 0
                ? `A$${calculatedPrice.toFixed(decimalPlaces)}`
                : String(currencyFormat(calculatedPrice, context));
        return formattedPrice;
    };

    if (enabledIncExPrices) {
        const exPriceText = `${getPrice()} Ex.`;
        const incPriceText = `(${getPrice(inclusiveRate || 1.1)} Inc.)`;
        return (
            <span className='aus-price'>
                <span className='ex'>{exPriceText}</span>
                <span className='inc'>{incPriceText}</span>
            </span>
        );
    } else {
        return <>{getPrice()}</>;
    }
};

export const isRequestPrice = (price: ProductPrice, LineDiscountGroup: string, isBundle?: boolean): boolean => {
    // true is for request price
    // false is for show price

    // For Bundles
    if (isBundle) {
        return true;
    } else if (LineDiscountGroup === 'RoC' && price.CustomerContextualPrice === 0) {
        return true;
    } else if (LineDiscountGroup === '' && price.CustomerContextualPrice === 0) {
        return true;
    } else if (LineDiscountGroup !== '' && LineDiscountGroup !== 'RoC' && price.DiscountAmount === 0) {
        return true;
    } else {
        return false;
    }
};

export const convertDateFormatToMMDDYYY = (inputDate: string) => {
    if (!inputDate) {
        return null;
    }
    const [day, month, year] = inputDate.split('/');
    const originalDate = new Date(`${month}/${day}/${year}`);
    const newMonth = originalDate.getMonth() + 1;
    const newDay = originalDate.getDate();
    const newYear = originalDate.getFullYear();
    const outputDate = `${newMonth.toString().padStart(2, '0')}/${newDay.toString().padStart(2, '0')}/${newYear}`;
    return outputDate;
};

export const _calculateWpPrice = (
    prodAttributes: AttributeValue[],
    context: ICoreContext<IGeneric<IAny>>,
    isBundle: boolean | undefined,
    activePrice: ProductPrice,
    customerInformation: Customer
) => {
    if (!prodAttributes && !activePrice) {
        return null;
    }
    const { enabledIncExPrices, incExPricePercentage } = context.app.config;
    const priceAttr = prodAttributes?.find(attr => attr.KeyName === 'PowerratingPmax(Wp)');
    const displayValueAttr = prodAttributes?.find(attr => attr.KeyName === 'DisplayWPPrice');
    if (priceAttr?.IntegerValue !== 0) {
        const price = priceAttr
            ? activePrice?.CustomerContextualPrice && activePrice?.CustomerContextualPrice / priceAttr?.IntegerValue!
            : null;
        const discountedWpPrice = priceAttr
            ? activePrice?.CustomerContextualPrice && activePrice?.CustomerContextualPrice / priceAttr?.IntegerValue!
            : null;
        const displayValue = displayValueAttr ? displayValueAttr.BooleanValue : false;

        if (
            displayValue &&
            price &&
            Number(priceAttr) !== 0 &&
            !isRequestPrice(activePrice, customerInformation?.LineDiscountGroup! ?? null, isBundle)
        ) {
            return (
                <div>
                    <div>
                        <span className='manufacturer-title'>WP Price:</span>
                        {
                            <span className='manufacturer-name'>
                                {incExcPriceFormat(discountedWpPrice!, context, enabledIncExPrices, incExPricePercentage, 3)}
                            </span>
                        }
                    </div>
                </div>
            );
        }
    }

    return null;
};
